var baseStyle = {
  table: {
    fontVariantNumeric: 'lining-nums tabular-nums',
    borderCollapse: 'separate',
    borderSpacing: '0 8px'
  }
};
var variantSimple = () => {
  return {
    th: {
      color: 'black',
      background: 'gray.240',
      borderBottom: '1px',
      borderRadius: '4px 4px 0 0',
      borderColor: 'gray.400',
      py: 0
    },
    td: {
      py: 0
    },
    tbody: {
      tr: {
        outline: 'thin solid',
        outlineColor: 'gray.300',
        background: 'gray.100',
        borderRadius: '4px'
      }
    }
  };
};
var variants = {
  simple: variantSimple,
  unstyled: {}
};
export var Table = {
  baseStyle,
  variants
};